export const NEXT_PARAM = 'next';
export const ORG_PARAM = 'org';
export const DIFFERENT_ORGANIZATION_PATH_NAME = '/different_organization';
